<script lang="ts">
  import type { IconsBaseProps } from './icons.types.ts';

  let { class: className, size = 6, title, ...rest }: IconsBaseProps = $props();
</script>

<svg viewBox="0 0 24 24" {...rest} width={size * 4} height={size * 4} class={className}>
  {#if title}<title>{title}</title>{/if}
  <path
    d="M10 5L7.5 10.5L2 13L7.5 15.5L10 21L12.5 15.5L18 13L12.5 10.5L10 5ZM18 3L16.75 5.75L14 7L16.75 8.25L18 11L19.25 8.25L22 7L19.25 5.75L18 3Z"
    fill="currentColor"
  />
</svg>
